var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"music-view-component",style:({
        backgroundImage: ("url(" + _vm.image + ")"),
        backgroundPosition: 'center center', 
        backgroundRepeat: 'repeat-x'
    }),on:{"click":function($event){return _vm.clickMusic()}}},[(_vm.audio)?_c('audio',{attrs:{"src":_vm.localAudio,"id":_vm.id,"preload":"auto"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }